import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import ImageLazyLoader from 'components/common/ImageLazyLoader';
import MelodyCarousel from 'components/common/MelodyCarousel';

import css from 'styles/components/productdetail/desktopSwatchPicker.scss';

const MAX_THUMBNAILS = 7;

function convertThumbnail(src) {
  return src.replace('t-THUMBNAIL', 'p-MOBILETHUMB');
}

function onImageLoadError(e) {
  e.target.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAB+ElEQVR4AY3UJdSuVRAF4Od75zPcNeFScHe3iEvCrXd6pOBQ8IhTsEzE3d3194HDP+Fg99691ivH9jqzZ/YYk1jDAnInEjki9U83t0N968zahITlJwf50uA9nIXjj+VsnDbmdPXU/2lHcTZOwikvDl59epBYgYUnBvd8EVY+Co/YRHwUbv8q5DODh7FgOxKHfBXO+zXkW+FZjOA+5gjEU8wU3gqPLob8IlyKQzcnzcmDOQveCFf8GPLd8LhCEu1ReDc88HPINwc3w4Gc2Yggd+cMhXfCpY3snfCUHng7PPDb+tp1CntxBlJl4nQVSpFd8sP6gac7kkd/WZ+7Fh5lCjitOGRlxHVMkqiDVxTZQ38+d/0U8u0KJxnaXqizSXcjjOFtZqXHZV+H/CvUwfXwMpNkhAD/R5REF87d74V8v26m8Dzj/yQa9xp1wi60cMJVb4ULSp8nod9bZ0tsToMucw/22VFh/vBf2ezFrrKnSH4uTVQYTReVza7ORlB2SmXSE+HN8PBvHUkylLCS6OusHADHF4fEKR+HO1vZvzG4EW5ldgtTjNvT0t10UQ5odmreHHMWEn5rLv4irH0ZrrCJaN5sRq+u8TusPjMoFzt0X87ckzO71nF6/9/sdDhn4ZDWNVoLwpqBxDJ+34rcfBMa25ysrrGA5TH5B65w8sQkEYt/AAAAAElFTkSuQmCC';
}

const makeSwatchThumbnail = (props, thumbnail) => {
  const { productStyles } = props;
  const imgProps = {
    'onError': onImageLoadError,
    'src': convertThumbnail(thumbnail.src),
    'alt': productStyles[thumbnail.styleId].color,
    'title': productStyles[thumbnail.styleId].color,
    'data-track-action': 'Product-Page',
    'data-track-label': 'PrImage',
    'data-track-value': 'Swatch'
  };
  const placeholder = <div className={css.swatchThumbnailPlaceholder} />;
  return <ImageLazyLoader imgProps={imgProps} placeholder={placeholder} />;
};

const makeSlider = thumbnailButtons => {
  const classes = {
    itemsViewport: css.sliderItemsViewport,
    prevButton: css.sliderButtons,
    nextButton: css.sliderButtons
  };
  return (
    <MelodyCarousel buttonsOutsideItemsViewport={true} classes={classes} showDots={false}>
      {thumbnailButtons}
    </MelodyCarousel>
  );
};

const DesktopSwatchPicker = (props, { testId }) => {
  const { selectedStyleId, thumbnails, onStyleChange } = props;
  if (thumbnails && thumbnails.length > 1) {
    const thumbnailButtons = thumbnails.map(thumbnail => {
      const btnClasses = cn(css.thumbWrap, {
        [css.selectedSwatch]: selectedStyleId === thumbnail.styleId
      });
      const { color } = props.productStyles[thumbnail.styleId];
      const image = (
        <div
          className={cn(css.swatchThumbnail, { [css.selectedSwatch]: selectedStyleId === thumbnail.styleId })}
          aria-label={`${selectedStyleId === thumbnail.styleId ? 'Active' : 'Toggle'} product color ${color}`}>
          {makeSwatchThumbnail(props, thumbnail)}
        </div>
      );
      return (
        <button
          type="button"
          key={thumbnail.styleId}
          className={btnClasses}
          onClick={onStyleChange}
          data-style-id={thumbnail.styleId}>
          {image}
        </button>
      );
    });

    return (
      <div className={css.swatchPicker} data-test-id={testId('swatchPicker')}>
        <div>
          {thumbnails.length <= MAX_THUMBNAILS ?
            thumbnailButtons : makeSlider(thumbnailButtons)
          }
        </div>
      </div>
    );
  } else {
    return (
      <div className={css.emptySwatchPicker} />
    );
  }
};

DesktopSwatchPicker.propTypes = {
  productStyles: PropTypes.object.isRequired,
  selectedStyleId: PropTypes.string.isRequired,
  onStyleChange: PropTypes.func.isRequired,
  thumbnails: PropTypes.arrayOf(PropTypes.object)
};

DesktopSwatchPicker.contextTypes = {
  testId: PropTypes.func
};

export default DesktopSwatchPicker;
